import { Box, Button, Container, Grid } from '@mui/material';
import React, { useState } from 'react';
import Header from '../Header/Header';
import HomeSearchBox from '../HomeSearchBox/HomeSearchBox';
import FlightIcon from '@mui/icons-material/Flight';
import DownloadIcon from '@mui/icons-material/Download';
import './Dashboard.css';
import { useNavigate } from 'react-router-dom';
const item = [
  { name: 'Search pad', value: 'flight', icon: 'FlightIcon' },
  { name: 'PNR Imports', value: 'pnr', icon: 'DownloadIcon' },
];

const Dashboard = () => {
  const navigate = useNavigate();
  const [system, setSystem] = useState('flight');
  const [type, setType] = useState('flight');
  const [importData, setImportData] = useState({});
  const handleSystemChange = (newValue) => {
    setSystem(newValue);
  };
  const handleTypeChange = (event, newValue) => {
    setType(newValue);
  };
  const handleChange = (e) => {
    setImportData({ ...importData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (event, newValue) => {
    navigate('/user/pnrimport', {
      state: {
        system: importData?.system,
        pnr: importData?.pnr,
      },
    });
  };
  return (
    <Box>
      <Header />
      <Box
        sx={{
          width: '100%',
          height: '100vh',
        }}
      >
        <Box mt={{ xs: 12, md: 5 }}>
          <Container>
            <Box
              sx={{
                boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                p: { xs: 1, sm: 2 },
                borderRadius: '10px',
                width: 'fit-content',
              }}
            >
              <Grid container spacing={2}>
                {item.map((button) => (
                  <Grid item key={button.value}>
                    <Box
                      onClick={() => handleSystemChange(button.value)}
                      sx={{
                        cursor: 'pointer',
                        textTransform: 'capitalize',
                        fontWeight: 500,
                        fontSize: 14,
                        borderRadius: '5px',
                        display: 'flex',
                        alignItems: 'center',
                        py: 0.5,
                        px: 1,
                        border:
                          system === button.value
                            ? '1px solid var(--yello-color)'
                            : '1px solid var(--secondary-color)',
                        bgcolor:
                          system === button.value ? 'var(--yello-color)' : '',
                        color:
                          system === button.value
                            ? 'var(--white)'
                            : 'var(--black)',
                        '&:hover': {
                          bgcolor:
                            system === button.value ? 'var(--yello-color)' : '',
                        },
                        width: '160px',
                      }}
                    >
                      {button.value === 'flight' ? (
                        <>
                          <FlightIcon
                            sx={{
                              border:
                                system === button.value
                                  ? '1px solid var(--white)'
                                  : '1px solid var(--secondary-color)',
                              borderRadius: '50%',
                              // bgcolor: 'var(--yello-color)',
                              p: 0.5,
                              fontSize: 35,
                            }}
                          />
                          &nbsp;&nbsp;&nbsp;
                          {button.name}
                        </>
                      ) : (
                        <>
                          <DownloadIcon
                            sx={{
                              border:
                                system === button.value
                                  ? '1px solid var(--white)'
                                  : '1px solid var(--secondary-color)',
                              borderRadius: '50%',
                              // bgcolor: 'var(--yello-color)',
                              p: 0.5,
                              fontSize: 35,
                            }}
                          />
                          &nbsp;&nbsp;&nbsp;{button.name}
                        </>
                      )}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Container>
          <Container>
            {system === 'pnr' && (
              <Box
                sx={{
                  boxShadow:
                    ' rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
                  p: { xs: 1, sm: 3, md: 3 },
                  my: 3,
                  borderRadius: '10px',
                  height: 'fit-content',
                  width: { xs: '100%', sm: '550px', md: '600', lg: '600px' },
                }}
              >
                <form onSubmit={handleSubmit}>
                  <Grid
                    container
                    spacing={2}
                    // alignItems="end"
                    justifyContent={'start'}
                  >
                    <Grid style={{ position: 'relative' }} item xs={12} sm={6}>
                      <Box className="custom-selects">
                        <select
                          onChange={handleChange}
                          value={importData?.system}
                          name="system"
                          required
                        >
                          <option value="">Select System</option>
                          <option
                            value="sabre"
                            style={{
                              fontSize: '14px',
                              padding: '10px',
                              width: '100%',
                              outline: 'none',
                            }}
                          >
                            Sabre
                          </option>
                        </select>
                      </Box>
                    </Grid>

                    <Grid style={{ position: 'relative' }} item xs={12} sm={6}>
                      <input
                        required
                        name="pnr"
                        placeholder="Enter PNR"
                        style={{
                          width: '100%',
                          border: 'none',
                          borderRadius: '4px',
                          padding: '10px 15px',
                          outline: 'none',
                          color: 'var(--secondary-color)',
                          fontWeight: 500,
                          background: '#ebebeb',
                        }}
                        type="text"
                        value={importData?.pnr}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: 'flex',
                        justifyContent: 'start',
                        alignItems: 'end',
                        gap: '5px',
                      }}
                    >
                      <Button
                        sx={{
                          background: 'var(--yello-color)',
                          color: 'white',
                          padding: '7px 20px !important',
                          fontSize: '12px !important',
                          width: '100%',
                          '&:hover': {
                            background: 'var(--yello-color)',
                            color: 'white',
                          },
                        }}
                        type="submit"
                      >
                        PROCEED
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            )}
          </Container>
          {system === 'flight' && (
            <Box>
              <HomeSearchBox
                type={type}
                setType={setType}
                handleTypeChange={handleTypeChange}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
